import useRegions from '@/sections/region/hooks/useRegions';

export const useFindLocations = () => {
  const { data } = useRegions();

  const findRegion = (regionId: number) => {
    const regionFounded = data?.find((region) => region.id === regionId);
    return regionFounded;
  };

  const findRegionName = (regionId: number) => {
    const regionName = findRegion(regionId);
    return regionName?.name ?? regionId?.toString();
  };

  const findCommuneName = (regionId: number, communeCode: string) => {
    const region = findRegion(regionId);
    const communeName = region?.communes?.find(
      (commune) => commune.code === communeCode
    );
    return communeName?.name ?? communeCode?.toString();
  };

  return {
    findRegion,
    findRegionName,
    findCommuneName
  };
};
